import CirclePattern from "./CirclePattern";

const LOGOS = [
  {
    name: "Duchy Homes",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/uclxx9c5_image.png",
  },
  {
    name: "Lovell",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/yqez0z2h_image.png",
  },
  {
    name: "Sunseeker Holiday Homes",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/x1jsvuwx_image.png",
  },
  {
    name: "LJ Sapphire Chalets",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/woo6xzqv_image.png",
  },
  {
    name: "Algeco",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/wyk5hbn6_image.png",
  },
  {
    name: "Later Living by Lovell",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/80ipokyk_image.png",
  },
  {
    name: "Fischer",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/esxpeshl_image.png",
  },
  {
    name: "Crowdit Buildit",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/0ydi44r5_image.png",
  },
  {
    name: "Repton Property Developments",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/xlh8z4w5_image.png",
  },
  {
    name: "Home Plus Group",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/n0a5aakf_image.png",
  },
  {
    name: "HCHA — Hull Churches Housing Association",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/ulgnytng_image.png",
  },
  {
    name: "Flagship Homes",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/966htlnm_image.png",
  },
  {
    name: "Azza Construction",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/1qrt2ndk_Picture7.png",
  },
  {
    name: "Consensus",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/5xibukfw_image.png",
  },
  {
    name: "Rinde Group Property",
    src: "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/30cifvnk_image.png",
  },
];

export default function CustomerLogos() {
  return (
    <section id="about" data-testid="customers-section" className="py-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <CustomersHeader />
        <LogoGrid />
      </div>
      <ClosingBanner />
    </section>
  );
}

function CustomersHeader() {
  return (
    <div className="max-w-4xl">
      <div className="overline mb-6">About</div>
      <h2
        data-testid="customers-headline"
        className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-[-0.02em] leading-[1.05] text-ecoh-ink"
      >
        Proven across a wide range of projects.
      </h2>
      <p className="mt-6 max-w-2xl text-ecoh-ink/70 text-lg md:text-xl font-light leading-snug">
        From individual homes to large-scale developments.
      </p>
      <div className="mt-10 max-w-3xl space-y-6 text-ecoh-muted text-base md:text-lg font-light leading-relaxed">
        <p>
          ecoHeatwave is specified and installed by house builders,
          self-build specialists, modular manufacturers, and commercial
          developers across the UK.
        </p>
        <p>
          The system has been successfully delivered across a diverse range
          of applications — from complete new-build housing developments
          and modular construction projects to leisure accommodation, later
          living schemes, and commercial office spaces.
        </p>
        <p>
          This breadth of experience demonstrates the flexibility of
          ecoHeatwave, adapting to different building types, construction
          methods, and performance requirements while maintaining
          consistent comfort and efficiency.
        </p>
        <p>
          For those looking to explore how ecoHeatwave performs in
          real-world applications, detailed project examples and case
          studies are available on request.
        </p>
      </div>
    </div>
  );
}

function logoTestId(name) {
  return `logo-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
}

function LogoGrid() {
  return (
    <div className="mt-16 md:mt-20 rounded-3xl bg-white ring-1 ring-ecoh-ink/10 shadow-sm p-6 md:p-10 lg:p-12">
      <ul
        data-testid="customers-logo-grid"
        className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-px bg-ecoh-ink/8 rounded-2xl overflow-hidden"
      >
        {LOGOS.map((l) => (
          <li
            key={l.name}
            data-testid={logoTestId(l.name)}
            className="bg-white aspect-[4/3] flex items-center justify-center p-6 md:p-8 transition-transform duration-500 hover:scale-[1.03]"
          >
            <img
              src={l.src}
              alt={l.name}
              loading="lazy"
              className="max-h-16 md:max-h-20 w-auto max-w-full object-contain"
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

function ClosingBanner() {
  return (
    <div className="relative bg-ecoh-ink text-white overflow-hidden mt-16 md:mt-20">
      <CirclePattern
        className="pointer-events-none select-none absolute inset-0 w-full h-full"
        opacity={0.5}
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-ecoh-ink via-ecoh-ink/80 to-ecoh-ink/40" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <p
          data-testid="customers-tagline"
          className="max-w-4xl font-display text-2xl md:text-3xl lg:text-4xl font-light tracking-[-0.02em] leading-[1.15] text-white"
        >
          Trusted by leading UK developers and specifiers.
        </p>
      </div>
    </div>
  );
}
